function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2 0.6L20.875 5.5H22C23.1046 5.5 24 6.39543 24 7.5V12C24 12.5523 23.5523 13 23 13H21C21 14.7 19.7 16 18 16C16.3 16 15 14.7 15 13H9C9 14.7 7.7 16 6 16C4.3 16 3 14.7 3 13H1C0.447715 13 0 12.5523 0 12V6.5C0 5.94772 0.447716 5.5 1 5.5H10.5V1C10.5 0.447715 10.9477 0 11.5 0H16.2648C16.5992 0 16.9114 0.1671 17.0969 0.445298L17.2 0.6ZM16 1.5L19 5.5H12V1.5H16ZM6 14.5C5.2 14.5 4.5 13.8 4.5 13C4.5 12.2 5.2 11.5 6 11.5C6.8 11.5 7.5 12.2 7.5 13C7.5 13.8 6.8 14.5 6 14.5ZM18 14.5C17.2 14.5 16.5 13.8 16.5 13C16.5 12.2 17.2 11.5 18 11.5C18.8 11.5 19.5 12.2 19.5 13C19.5 13.8 18.8 14.5 18 14.5ZM12 7H14V8H12V7Z"
});

function SvgPickup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "#037BFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.e55a95c8.svg";
export { ForwardRef as ReactComponent };